
<script>
export default {
  name: 'BaseFormData',
  props: {
    validations: {
      type: Object
    }
  },
  data() {
    return {
      dataReady: true
    }
  },
  computed: {
    $v() {
      if (this.validations) {
        return this.validations
      }
      return {}
    }
  }
}
</script>
